import uuid from '@/Utils/Uuid';

const sessionId = uuid();

export default sessionId;
